import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Grid, Paper, Typography} from "@material-ui/core";

class PBNInfo extends Component {
    render() {
        let dealer = '';

        switch (this.props.pbnDealer) {
            case 0:
                dealer = 'North';
                break;
            case 1:
                dealer = 'East';
                break;
            case 2:
                dealer = 'South';
                break;
            case 3:
                dealer = 'West';
                break;
        }

        return (
            <Grid container style={{padding:'5px'}}>
                <Grid item xs={12}>
                    <Typography variant={"body1"} inline>Board: </Typography>
                    <Typography variant={"body1"} inline color={"primary"}>{this.props.pbnBoardNumber}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={"body1"} inline>Dealer: </Typography>
                    <Typography variant={"body1"} inline color={"primary"}>{dealer}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={"body1"} inline>Vulnerable: </Typography>
                    <Typography variant={"body1"} inline color={"primary"}>{this.props.pbnVulnerable}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={"body1"} inline>Scoring: </Typography>
                    <Typography variant={"body1"} inline color={"primary"}>{this.props.pbnScoring}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={"body1"}>&nbsp;</Typography>
                </Grid>
            </Grid>
        );
    }
}

PBNInfo.propTypes = {
    pbnBoardNumber: PropTypes.number.isRequired,
    pbnVulnerable: PropTypes.string,
    pbnDealer: PropTypes.string,
    pbnScoring: PropTypes.string
}

export default PBNInfo;